
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { API_TCaseRow } from "@/models/case_profiles";
import { TStep } from "@/models/questionnaire";
import { SMQuestionnaire } from "@/store";

@Component({
  components: {
    ProfileRow: () => import("@/components/DetailsSummaryPage/components/ProfileRow.vue"),
  },
})
export default class ProfileTemplate extends Vue {
  @Prop({ type: String, required: true }) readonly title!: string;
  @Prop({ type: Array }) readonly rows!: API_TCaseRow[];
  @Prop({ type: Boolean, default: false }) readonly isEditable!: boolean;

  get hasData() {
    return this.$slots["default"];
  }

  get lastUpdatedStep() {
    return SMQuestionnaire.lastUpdatedStep;
  }

  @Watch("lastUpdatedStep", { deep: true })
  lastUpdatedStepChanged(val: TStep) {
    const index = this.rows.findIndex((row) => row.step.ID === val.ID);

    if (index < 0) return;

    this.rows[index].step = val;
  }

  isEditEnable(skipStep: boolean) {
    return this.isEditable && !skipStep;
  }

  emitEdit(payload: { caseId: number; stepId: number; type: string }) {
    this.$emit("edit", payload);
  }
}
